import React, { useEffect, useRef } from "react";
import { Button } from "../bootstrap/index.jsx";
import Tether from 'tether'

const DropdownMenu = ({
  label,
  align,
  classes,
  btnClass = "",
  btnType,
  btnStyle,
  btnSize,
  containerClass,
  children,
  linkAsToggle,
  hideOnClick = true,
  disabled = false,
  containerStyle = {}
}) => {
  const itemsRef = useRef();
  const rootRef = useRef();
  const toggleRef = useRef();

  useEffect(() => {
    jQuery(itemsRef.current).find("> *:not(.divider, .dropdown-item)").addClass("dropdown-item");
  });

  const handleClick = (e) => {
    // Handle toggle click separately
    if (
      jQuery(toggleRef.current).is(e.target) ||
      jQuery(toggleRef.current).has(e.target).length > 0
    )
      return;

    // Hide on click
    // When props hideOnClick is true (default)
    if (
      jQuery(rootRef.current).hasClass("open") &&
      (hideOnClick ||
        // When click is inside and target has data-close-dropdown="true"
        (jQuery(rootRef.current).has(e.target).length > 0 &&
          jQuery(e.target).data("close-dropdown")) ||
        // When click is outside
        (!jQuery(rootRef.current).is(e.target) &&
          jQuery(rootRef.current).has(e.target).length === 0 &&
          jQuery(".open").has(e.target).length === 0))
    ) {
      jQuery(rootRef.current).removeClass("open");
    }
  };

  useEffect(() => {
    jQuery("body").on("click", handleClick);

    return () => {
      jQuery("body").off("click", handleClick);
    };
  }, []);

  const onToggle = (e) => {
    e.preventDefault();
    jQuery(rootRef.current).toggleClass("open");
  };

  const toggleProps = {
    "aria-haspopup": "true",
    "aria-expanded": "false",
    "data-auto-close": "false",
    className: `dropdown-toggle ${btnClass}`,
    style: btnStyle,
    type: btnType,
    size: btnSize,
    onClick: onToggle,
    disabled,
  };

  const toggle = linkAsToggle ? (
    <a ref={toggleRef} {...toggleProps}>
      {label}
    </a>
  ) : (
    <Button btnRef={toggleRef} {...toggleProps}>
      {label}
    </Button>
  );

  return (
    <div
      ref={rootRef}
      className={["dropdown"].concat(containerClass ? [containerClass] : []).join(" ")}
      style={containerStyle}
    >
      {toggle}
      <ul
        ref={itemsRef}
        className={["dropdown-menu"]
          .concat(align == "right" ? " dropdown-menu-right" : "")
          .concat(classes)
          .join(" ")}
      >
        {children}
      </ul>
    </div>
  );
};

export default DropdownMenu;

export const Divider = () => <li role="separator" className="divider"></li>;

export class TetherDropdownMenu extends React.Component {
  constructor(props) {
    super(props);

    this.rootRef = React.createRef();
  }

  render() {
    const toggle = React.createElement(this.props.toggleElem || "button", {
      key: "toggle",
      className: "dropdown-toggle cursor-pointer",
      onMouseDown: this.btnClicked,
      onClick: this.toggle,
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      children: this.props.btnLabel,
    });

    const container = React.createElement(this.props.rootElem || "div", {
      ref: this.rootRef,
      className: this.props.className,
      children: [
        toggle,
        React.createElement(this.props.menuElem || "div", {
          key: "menu",
          className: "dropdown-menu",
          children: this.props.children,
        }),
      ],
    });

    return container;
  }

  toggle = (event) => {
    jQuery(event.currentTarget).dropdown();

    event.preventDefault();
    event.stopPropagation();
  };

  btnClicked = (event) => {
    jQuery(event.currentTarget).parent().attr("data-mouse-x", event.clientX);
    event.stopPropagation();
  };

  componentDidMount() {
    jQuery(this.rootRef.current).on("show.bs.dropdown", (event) => {
      let container = jQuery(event.currentTarget);
      let menu = container.find(".dropdown-menu").appendTo("body").show();

      let offset = this.props.target == "mouse" ? "0 " + (container.offset().left + container.outerWidth() - parseInt(container.attr("data-mouse-x"), 10)) + "px" : "0 0";

      let tether = new Tether({
        element: menu,
        target: container,
        attachment: "top right",
        targetAttachment: "bottom right",
        offset: offset,
      });

      container.off("hide.bs.dropdown").on("hide.bs.dropdown", (event) => {
        menu.hide().appendTo(container);
        tether.destroy();
      });
    });
  }
}
